var map = {
	"./shaffi11-large.jpg": "k1am",
	"./shaffi11-medium.jpg": "B7t3",
	"./shaffi11-small.jpg": "DrC8",
	"./shaffi11-xlarge.jpg": "UdZ4",
	"./shaffi11-xsmall.jpg": "ZihT",
	"./shaffi11.jpg": "wTDx"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "JBMF";


//////////////////
// WEBPACK FOOTER
// ./assets/header ^\.\/.*$
// module id = JBMF
// module chunks = 0